// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateConfigReducer extends Reducer
{
	public static reducerName: string = "UpdateConfig";
	public static call(_platform: string, _channel: string, _updateHz: number, _authentication: boolean, _strictMode: boolean) {
		this.getReducer().call(_platform, _channel, _updateHz, _authentication, _strictMode);
	}

	public call(_platform: string, _channel: string, _updateHz: number, _authentication: boolean, _strictMode: boolean) {
		const serializer = this.client.getSerializer();
		let _platformType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		serializer.write(_platformType, _platform);
		let _channelType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		serializer.write(_channelType, _channel);
		let _updateHzType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_updateHzType, _updateHz);
		let _authenticationType = AlgebraicType.createPrimitiveType(BuiltinType.Type.Bool);
		serializer.write(_authenticationType, _authentication);
		let _strictModeType = AlgebraicType.createPrimitiveType(BuiltinType.Type.Bool);
		serializer.write(_strictModeType, _strictMode);
		this.client.call("UpdateConfig", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let platformType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		let platformValue = AlgebraicValue.deserialize(platformType, adapter.next())
		let platform = platformValue.asString();
		let channelType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		let channelValue = AlgebraicValue.deserialize(channelType, adapter.next())
		let channel = channelValue.asString();
		let updateHzType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let updateHzValue = AlgebraicValue.deserialize(updateHzType, adapter.next())
		let updateHz = updateHzValue.asNumber();
		let authenticationType = AlgebraicType.createPrimitiveType(BuiltinType.Type.Bool);
		let authenticationValue = AlgebraicValue.deserialize(authenticationType, adapter.next())
		let authentication = authenticationValue.asBoolean();
		let strictModeType = AlgebraicType.createPrimitiveType(BuiltinType.Type.Bool);
		let strictModeValue = AlgebraicValue.deserialize(strictModeType, adapter.next())
		let strictMode = strictModeValue.asBoolean();
		return [platform, channel, updateHz, authentication, strictMode];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _platform: string, _channel: string, _updateHz: number, _authentication: boolean, _strictMode: boolean) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _platform: string, _channel: string, _updateHz: number, _authentication: boolean, _strictMode: boolean) => void)
	{
		this.client.on("reducer:UpdateConfig", callback);
	}
}


export default UpdateConfigReducer
